import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { BoxProps, theme } from '@dtx-company/shared-components/src'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import styled from 'styled-components'

export const AddOnCard = styled(Box)<BoxProps>(() => {
  return {
    border: `1px ${theme.colors.secondary.border} solid`,
    borderRadius: '8px',
    padding: '16px'
  }
})

export const NumberDropdownBox = styled(Box)<BoxProps>(() => {
  return {
    border: `1px ${theme.colors.secondary.border} solid`,
    background: theme.colors.primary.white,
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '8px',
    padding: '8px',
    width: '48px'
  }
})

export const NumberDropdownMenu = styled(Box)<BoxProps>(() => {
  return {
    border: `1px ${theme.colors.secondary.border} solid`,
    background: theme.colors.primary.white,
    borderRadius: '0px 8px 8px 8px',
    flexDirection: 'column',
    position: 'absolute',
    overflow: 'auto',
    padding: '4px',
    width: '100%',
    top: '44px',
    zIndex: 2
  }
})

export const DropdownNumbers = styled(Text)<BoxProps>(() => {
  return {
    borderRadius: '4px',
    padding: '4px',
    ':hover': {
      background: theme.colors.secondary.highlight
    }
  }
})
